export default function() {
    const self = this,
        symplaTokenId = self.$route.params.id

    self.resetFormResult()

    if (symplaTokenId) {
        self.loadSymplaToken(symplaTokenId)
    }
}
